import {Brick, registerBrick, Color, BrickContext} from 'olympe';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Button from '@mui/material/Button';

/**
 * Brick that display a simple popup (mui component)
 */
export default class ShowPopup extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (title, text, color, icon) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} title
     * @param {string} text
     * @param {Color} color
     * @param {string} icon
     * @param {function()} forwardEvent
     */
    update(context, [title, text, color, icon], [forwardEvent]) {
        const popupId = 'popup017c3c251ba300f011c0';
        if (!document.getElementById(popupId)) {
            const head = document.body;
            const popup = document.createElement('div');
            popup.id = popupId;
            head.appendChild(popup);
        }

        ReactDOM.render((<ShowPopup.Component
            title={title}
            text={text}
            context={context}
            color={color}
            icon={icon}
            forwardEvent={forwardEvent}
        />), document.getElementById(popupId));
    }
}

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.text
 * @param {BrickContext} props.context
 * @param {Color} props.color
 * @param {function()} props.forwardEvent
 * @return {JSX.Element}
 * @constructor
 */
ShowPopup.Component = (props) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        document.getElementById('popup017c3c251ba300f011c0').remove();
        props.forwardEvent();
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            aria-labelledby="popup-title"
            style={{flexDirection: 'row'}}
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: props.color.toHexString(), width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>{props.icon}</i>
                </div>
                <div>
                    <DialogTitle id="popup-title">{props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="popup-description">
                            {props.text}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>
                            Ok
                        </Button>
                    </DialogActions>
                </div>
            </div>

        </Dialog>
    );
};

ShowPopup.Component.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.string,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    color: PropTypes.instanceOf(Color),
    forwardEvent: PropTypes.func,
};

registerBrick('017c3c251ba300f011c0', ShowPopup);
